const session = {
    expiredDueToInactivity: 'Your session has expired due to inactivity.',
    expiresSoon: 'Your session will expire in 5 minutes due to inactivity.',
    expired: 'Your session has expired. Please log in again.',
    extended: 'Session extended.',
    staySignedIn: 'Stay signed in',
  };

export default session;
